+function ($) {
    'use strict';

    var AjaxPaginator = function (element, options) {
        this.element = $(element);
        this.nextPageBtn = this.element.find('.ajax-paginator__link');
        this.target = this.element.data('target');
        this.option = this.element.data('option');
        var self = this;
        this.nextPageBtn.click(function () {
            self.getNexPage();
            return false;
        });
    };

    AjaxPaginator.prototype.getNexPage = function () {
        var path = this.nextPageBtn.attr('href');
        var linked = false;
        if(!path) {
            path = this.nextPageBtn.data('link');
            linked = true;
        }
        this.nextPageBtn.addClass('disabled');
        $.ajax({
            url: path,
            context: this,
            success: function (data) {
                if (this.option) {
                    data = $(data);
                } else {
                    data = $('<iframe></iframe>').html(data).find('.data');
                }

                var paginator = null;
                if(!linked) {
                    paginator = data.find('.ajax-paginator > .ajax-paginator__link').attr('href');
                } else {
                    paginator = data.find('.ajax-paginator > .ajax-paginator__link').data('link');
                }

                if (paginator) {
                    if(!linked) {
                        this.nextPageBtn.attr('href', paginator);
                    } else {
                        this.nextPageBtn.data('link', paginator);
                    }

                } else {
                    this.nextPageBtn.remove();
                }
                data.find('.ajax-paginator').remove();
                if (this.target) {
                    data = data.find(this.target);
                    $(this.target).append(data.children());
                    $(this.target).trigger('loadPage');
                } else {
                    $('.ajax-paginator').before(data.children());
                }
                this.nextPageBtn.removeClass('disabled');
            }

        });
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            new AjaxPaginator(this, options);
        });
    };



    var old = $.fn.ajaxPaginator;

    $.fn.ajaxPaginator = constructor;
    $.fn.ajaxPaginator.constructor = constructor;

    $.fn.ajaxPaginator.noConflict = function () {
        $.fn.ajaxPaginator = old;
        return this;
    }
}(jQuery);